module.exports = __webpack_public_path__ + "img/HamochiX.0c8aa413.png";